var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section-expander",
    { staticClass: "_h-full" },
    [
      _vm.isInitialized
        ? [
            _c(
              "div",
              { class: _vm.wrapperClassList },
              [
                _vm.isLaunchCampaignBoxEnabled
                  ? _c("launch-project-box")
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isLaunchCampaignBoxEnabled
                  ? _c("info-tile-list", {
                      attrs: { items: _vm.projectTypeTags },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "_flexcol _gap-1",
                    attrs: {
                      role: "region",
                      "aria-labelledby": "home-categories-title",
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { id: "home-categories-title" } },
                      [
                        _c("base-icon", {
                          attrs: { name: "shape", "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.Resources.ProjectHome
                                .ProjectPropertiesCategoryLabel
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasCategoriesSubItems
                      ? [
                          _c("grouped-box-list", {
                            attrs: {
                              items: _vm.categoryItems,
                              "data-qa": "ProjectCategoryTree",
                            },
                          }),
                        ]
                      : [
                          _c("info-tile-list", {
                            attrs: { items: _vm.categoryItems },
                          }),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    class: _vm.globalTagsClassList,
                    attrs: {
                      role: "region",
                      "aria-labelledby": "home-global-tags-title",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "_z-2",
                        attrs: { id: "home-global-tags-title" },
                      },
                      [
                        _c("base-icon", {
                          attrs: { name: "hashtag", "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.Resources.Homepage.ProjectListGlobalTagsTitle
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "scrollable-wrapper",
                      {
                        attrs: {
                          "scroll-direction": _vm.scrollDirections.vertical,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "_flexcol _gap-1" },
                          [
                            _c("box-list", {
                              attrs: { items: _vm.projectGlobalTags },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "_flexcol _gap-6" },
              [
                _c("skeleton-tile", { attrs: { "items-count": 4 } }),
                _vm._v(" "),
                _c("skeleton-tile", { attrs: { "items-count": 2 } }),
                _vm._v(" "),
                _c("skeleton-box-list", { attrs: { "items-count": 20 } }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }